import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_MAIL_RECIPIENT_GROUPS } from '@/api/endpoints';
import { MAIL_RECIPIENT_GROUPS_QUERY_KEY } from '@/api/queryKeys';
import { useUserContext } from '@/auth/UserContext';
import type { RecipientGroupResponse } from '@/types/mail';
import { unwrapAxiosResponse } from '@/utils/axios';

export const useRecipientGroups = () => {
  const { user } = useUserContext();
  const studyYear = user?.studyYear;

  const { data: groups, isFetching } = useQuery<RecipientGroupResponse[]>({
    queryKey: [...MAIL_RECIPIENT_GROUPS_QUERY_KEY, studyYear?.id],
    queryFn: () =>
      apiClient
        .get<RecipientGroupResponse[]>(API_MAIL_RECIPIENT_GROUPS, {
          params: { studyYearId: studyYear?.id },
        })
        .then(unwrapAxiosResponse),
    enabled: !!studyYear,
    staleTime: Infinity,
  });

  return { groups: groups ?? [], studyYear, isFetching };
};
